import React, { useState, useEffect } from "react";
import Input from "../../components/Input";
import InputSelect from "../../components/InputSelect";
import InputDate from "../../components/InputDate";
import InputMask from "../../components/InputMask";
import { Row, Col } from "antd";
import { LoadingOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { getAllStates, getAllCities, getStateCities } from "easy-location-br";
import countries from "../../utils/countries";
import { normalizeText } from "../../utils/removeMask";

export default function FormPersonal({
  register,
  control,
  errors,
  onPrevious,
  onNext,
  loading,
  setValue,
}) {
  const [selectState, setSelectState] = useState([]);
  const [selectCity, setSelectCity] = useState([]);
  const [currentState, setCurrentState] = useState(null);
  const [currentCountry, setCurrentCountry] = useState("");
  const [occupation, setOccupation] = useState("");
  const [removeCaracterName, setRemoveCaracterName] = useState("");

  useEffect(() => {
    const states = getAllStates().map((s) => ({ label: s.name, value: s.id }));
    setSelectState(states);
    setCurrentCountry("BR");
  }, []);

  useEffect(() => {
    const cities = getStateCities(currentState).map((s) => ({
      label: s.name,
      value: s.name,
    }));

    setSelectCity(cities);
  }, [currentState]);

  const date = new Date().setFullYear(new Date().getFullYear() - 18);

  function fnRemoveCaracterName(e) {
    const value = normalizeText(e.target.value.toUpperCase());
    setRemoveCaracterName(value);
  }

  function fnRemoveCaracter(e) {
    const value = normalizeText(e.target.value);
    setOccupation(value);
  }

  return (
    <div key="formPersonal">
      <Row gutter={16} className="__auth-mb-25">
        <Col xs={24} sm={24} md={12} lg={12}>
          <Input
            label="Nome"
            placeholder="Digite o seu nome completo"
            register={register("fullName")}
            required
            error={errors.fullName?.message}
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          <InputMask
            name="taxId"
            type="tel"
            control={control}
            label="CPF"
            placeholder="Digite o seu CPF"
            mask="999.999.999-99"
            maskChar={null}
            required
            error={errors.taxId?.message}
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          <InputDate
            label="Data de nascimento"
            placeholder="Digite sua data de nascimento"
            control={control}
            required
            name="birthDate"
            maxDate={date}
            minDate={new Date("1900")}
            error={errors.birthDate?.message}
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          <div key="divInput">
            <Input
              key="inputEmail"
              label="Email para seu login"
              placeholder="Digite o seu email pessoal"
              register={register("personalEmail", {
                setValueAs: (value) => value.replace(/ /g, ""),
              })}
              required
              error={errors.personalEmail?.message}
            />
          </div>
        </Col>

        <Col xs={24} sm={24} md={12} lg={12}>
          <InputMask
            key="mobile1"
            type="tel"
            label="Celular"
            placeholder="Digite seu número de celular"
            control={control}
            name="mobile1"
            mask="(99) 99999-9999"
            maskChar={null}
            required
            error={errors.mobile1?.message}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
        {/*   <Input
            key="inputIndication"
            label="Código de convidado"
            placeholder="Digite o código de indicação se possuir"
            register={register("indication")}
            error={errors.indication?.message}
            adornment={
              <div className="__auth-terms">
                <p style={{ marginLeft: "20px", marginBottom: "0" }}>
                  *opcional
                </p>
              </div>
            } */}
     {/*      /> */}
        </Col>
      </Row>
      <Row gutter={16} className="__signup-bottom-button">
        <Col xs={12}></Col>
        <Col xs={12}>
          <button
            type="button"
            className="__auth-button-primary"
            onClick={onNext}
            disabled={loading}
          >
            {loading ? <LoadingOutlined /> : "Próximo"}
          </button>
        </Col>
      </Row>
    </div>
  );
}
